import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { syncBlockMessages as messages } from '@atlaskit/editor-common/messages';
import AkFlag, { FlagGroup } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { syncedBlockPluginKey } from '../pm-plugins/main';
import { FLAG_ID } from '../types';
var flagMap = _defineProperty(_defineProperty(_defineProperty({}, FLAG_ID.CANNOT_DELETE_WHEN_OFFLINE, {
  title: messages.failToDeleteTitle,
  description: messages.failToDeleteWhenOfflineDescription
}), FLAG_ID.CANNOT_EDIT_WHEN_OFFLINE, {
  title: messages.failToEditTitle,
  description: messages.failToEditWhenOfflineDescription
}), FLAG_ID.CANNOT_CREATE_WHEN_OFFLINE, {
  title: messages.failToCreateTitle,
  description: messages.failToCreateWhenOfflineDescription
});
export var Flag = function Flag(_ref) {
  var api = _ref.api;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['syncedBlock'], function (states) {
      var _states$syncedBlockSt;
      return {
        showFlag: (_states$syncedBlockSt = states.syncedBlockState) === null || _states$syncedBlockSt === void 0 ? void 0 : _states$syncedBlockSt.showFlag
      };
    }),
    showFlag = _useSharedPluginState.showFlag;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if (!showFlag) {
    return;
  }
  var _flagMap$showFlag = flagMap[showFlag],
    title = _flagMap$showFlag.title,
    description = _flagMap$showFlag.description;
  var onDismissed = function onDismissed() {
    api === null || api === void 0 || api.core.actions.execute(function (_ref2) {
      var tr = _ref2.tr;
      tr.setMeta(syncedBlockPluginKey, {
        showFlag: false
      });
      return tr;
    });
    api === null || api === void 0 || api.core.actions.focus();
  };
  return /*#__PURE__*/React.createElement(FlagGroup, null, /*#__PURE__*/React.createElement(AkFlag, {
    onDismissed: onDismissed,
    title: formatMessage(title),
    description: formatMessage(description),
    id: showFlag,
    testId: showFlag,
    icon: /*#__PURE__*/React.createElement(StatusErrorIcon, {
      label: "",
      color: "var(--ds-icon-danger, #C9372C)"
    })
  }));
};